import React, { PureComponent } from "react";
import { Link } from "react-router";
import { changeLocation } from "api/Location";
import Logo from "./assets/LandingPageLogo.png";
import { postRequest } from "../api/ApiService";
import { detectMobile, getLogoStyle, logError } from "../services/utils";

const REGISTER_URL = `${process.env.REACT_APP_API_URL}account/register/`;
const FIELDS_STEP1 = ["first_name", "last_name", "course_code"];
const FIELDS_STEP2 = ["username", "password", "password_2", "email"];

class RegisterPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      first_name: "",
      last_name: "",
      course_code: "",
      username: "",
      password: "",
      password_2: "",
      email: "",
      validations: {},
      step: 1
    };

    this.isMobile = detectMobile();
  }

  handleInputChange = e => {
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  canChangeStep = () => {
    const { step, validations } = this.state;
    const fields = step === 1 ? FIELDS_STEP1 : FIELDS_STEP2;

    let result = true;
    fields.forEach(field => {
      if (field in validations && validations[field] !== "") {
        result = false;
      }
    });

    return result;
  };

  changeStep = () => {
    const { step } = this.state;

    if (step === 1) {
      this.setState({
        step: 2,
        validations: {}
      });
    } else if (step === 2) {
      changeLocation("/login?activation=1");
    }
  };

  updateValidations = validations => {
    this.setState(
      {
        validations
      },
      () => {
        if (this.canChangeStep()) {
          this.changeStep();
        }
      }
    );
  };

  goToNext = e => {
    let data = {};
    const keys = [
      "first_name",
      "last_name",
      "course_code",
      "username",
      "password",
      "password_2",
      "email"
    ];

    keys.forEach(key => {
      if (this.state[key] && this.state[key] !== "") {
        data[key] = this.state[key];
      }
    });

    postRequest(REGISTER_URL)
      .send(data)
      .then(response => {
        this.updateValidations({});
      })
      .catch(err => {
        if (err.response && err.response.statusCode === 400) {
          this.updateValidations(err.response.body);
        } else if (err.response && err.response.statusCode === 201) {
          this.updateValidations({});
        } else {
          logError(err, "RegisterPage", "goToNext");
        }
      });
  };

  onSubmit = e => {
    e.preventDefault();
  };

  hasError = key => {
    const { validations } = this.state;

    if (key in validations && validations[key] !== "") {
      return "form-group has-error register-error";
    }

    return "form-group";
  };

  getError = key => {
    const { validations } = this.state;

    if (key in validations && validations[key] !== "") {
      return <span className="help-block">{validations[key]}</span>;
    }

    return null;
  };

  render() {
    const {
      first_name,
      last_name,
      course_code,
      username,
      password,
      password_2,
      email,
      step
    } = this.state;
    const logoStyle = getLogoStyle(this.isMobile);
    const formClass = this.isMobile ? "mg-top-5vh" : "mg-top-10vh";
    const buttonStyle = this.isMobile
      ? {
          paddingTop: "20px"
        }
      : {};

    return (
      <div className="container-fluid bg-color-blue height-100vh">
        <div className="text-center mg-top-15vh">
          <Link to="/welcome">
            <img src={Logo} style={logoStyle} alt="Logo" />
          </Link>
        </div>
        <div className={formClass}>
          <form
            className="form-signin form-horizontal"
            onSubmit={this.onSubmit}
          >
            {step === 1 && (
              <div className={this.hasError("first_name")}>
                <label
                  htmlFor="first_name"
                  className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
                >
                  First Name
                </label>
                <div className="col-md-3 col-xs-12">
                  <input
                    id="first_name"
                    type="text"
                    value={first_name}
                    onChange={this.handleInputChange}
                    className="form-control border-radius-none"
                    placeholder="First Name"
                    required={true}
                    autoFocus={!this.isMobile}
                  />
                  {this.getError("first_name")}
                </div>
              </div>
            )}
            {step === 1 && (
              <div className={this.hasError("last_name")}>
                <label
                  htmlFor="last_name"
                  className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
                >
                  Last Name
                </label>
                <div className="col-md-3 col-xs-12">
                  <input
                    id="last_name"
                    type="text"
                    value={last_name}
                    onChange={this.handleInputChange}
                    className="form-control border-radius-none"
                    placeholder="Last Name"
                    required={true}
                  />
                  {this.getError("last_name")}
                </div>
              </div>
            )}
            {step === 1 && (
              <div className={this.hasError("course_code")}>
                <label
                  htmlFor="course_code"
                  className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
                >
                  Course Code
                </label>
                <div className="col-md-3 col-xs-12">
                  <input
                    id="course_code"
                    type="text"
                    value={course_code}
                    onChange={this.handleInputChange}
                    className="form-control border-radius-none"
                    placeholder="Course Code"
                    required={true}
                  />
                  {this.getError("course_code")}
                </div>
              </div>
            )}
            {step === 2 && (
              <div className={this.hasError("username")}>
                <label
                  htmlFor="username"
                  className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
                >
                  Username
                </label>
                <div className="col-md-3 col-xs-12">
                  <input
                    id="username"
                    type="text"
                    value={username}
                    onChange={this.handleInputChange}
                    className="form-control border-radius-none"
                    placeholder="Username"
                    required={true}
                    autoFocus={!this.isMobile}
                  />
                  {this.getError("username")}
                </div>
              </div>
            )}
            {step === 2 && (
              <div className={this.hasError("password")}>
                <label
                  htmlFor="password"
                  className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
                >
                  Password
                </label>
                <div className="col-md-3 col-xs-12">
                  <input
                    id="password"
                    type="password"
                    value={password}
                    onChange={this.handleInputChange}
                    className="form-control border-radius-none"
                    placeholder="Password"
                    required={true}
                  />
                  {this.getError("password")}
                </div>
              </div>
            )}
            {step === 2 && (
              <div className={this.hasError("password_2")}>
                <label
                  htmlFor="password_2"
                  className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
                >
                  Confirm password
                </label>
                <div className="col-md-3 col-xs-12">
                  <input
                    id="password_2"
                    type="password"
                    value={password_2}
                    onChange={this.handleInputChange}
                    className="form-control border-radius-none"
                    placeholder="Confirm password"
                    required={true}
                  />
                  {this.getError("password_2")}
                </div>
              </div>
            )}
            {step === 2 && (
              <div className={this.hasError("email")}>
                <label
                  htmlFor="email"
                  className="control-label font-size-14 color-white col-md-3 col-md-offset-2 col-xs-12"
                >
                  E-mail
                </label>
                <div className="col-md-3 col-xs-12">
                  <input
                    id="email"
                    type="text"
                    value={email}
                    onChange={this.handleInputChange}
                    className="form-control border-radius-none"
                    placeholder="E-mail"
                    required={true}
                  />
                  {this.getError("email")}
                </div>
              </div>
            )}
            <div className="form-group mg-top-3vh" style={buttonStyle}>
              <div className="col-md-2 col-md-offset-6 col-xs-12">
                <button
                  type={step === 2 ? "submit" : "button"}
                  onClick={this.goToNext}
                  className="btn login-btn btn-lg btn-block"
                >
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default RegisterPage;



// WEBPACK FOOTER //
// ./src/containers/register-page.js